'use client';
import { isSignedInAtom } from "@/hooks/authAtoms";
import { useAtom } from "jotai";
import { useRouter } from "@/app/components/lib/navigation/useRouter";
import SvgLogout from "./common-header-icons/SvgLogout";
import MenuLink from "./menu/MenuLink";
import { deleteTokens } from "@/utils/functions/cookieOperations";
import { useTranslation } from "@/hooks/localization/useTranslations";
import { useLang } from "@/providers/langProvider";

interface Props {
  mobile?: boolean;
}

const Logout: React.FC<Props> = ({ mobile = false }) => {
  const t = useTranslation();
  const [, setSignedIn] = useAtom(isSignedInAtom);
  const { push } = useRouter();
  const lang = useLang();
  return (
    <div style={mobile ? { marginTop: 64 } : {}}>
      <MenuLink
        isMobile={mobile}
        onClick={() => {
          deleteTokens();
          setSignedIn(false);
          push("/" + lang + "/");
        }}
        title={{ Svg: <SvgLogout />, text: t.logout }}
      />
    </div>
  );
};

export default Logout;
